import React from "react";
import { intl } from "../locales/localesConfig";
import CalculationUnitAdminActionsImg from "../../public/images/tours/calculationUnitAdmin/actions.png";
import LocaleTooling from "../tooling/localeTooling";


// = TOUR OPTIONS =
//  -  requiresPeriod: If true, the tour will only be shown/available if there's at least one period created.
//  -  steps: (required) An array of steps to be shown in the tour. Each step is an object with the "step options" below.
// = STEP OPTIONS = (Details on https://docs.react-joyride.com/step) 
//  -  target: (required) Uses a css selector to target the element to highlight
//  -  title: The text at the top of the tooltip, it can be plain text or a React.Node (javascript and/or html)
//  -  content: (required) The text inside the tooltip, it can also be plain text or a React.Node (javascript and/or html)
//  -  placement: The position of the tooltip pivoting from the target. See https://docs.react-joyride.com/step#:~:text=placement%20string%20%E2%96%B6%EF%B8%8E,to%20body)
//  -  onEnteringStepForwardsClick: The id of the DOM element to click when reaching this step in a forward order.
//  -  onEnteringStepBackwardsClick: The id of the DOM element to click when reaching this step in a backward order.


const onBoardingDefinitions = {
  admin: {
    home: {
      steps: [
        {
          target: '.dashboard_content_inner_view',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.tourIntroTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.tourIntro" })),
          disableBeacon: true,
          placement: 'center',
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // TOP MENU
        {
          target: ".dashboard_top_bar",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuIntroTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuIntro" })),
          placement: "bottom",
        },
        {
          target: ".top_menu_fixed_period",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuFixedPeriodTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuFixedPeriod" })),
          placement: "bottom",
        },
        {
          target: ".fa-tasks",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuNotificationsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuNotifications" })),
          placement: "bottom",
        },
        {
          target: ".fa-user-circle",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuUserProfileTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuUserProfile" })),
          placement: "bottom",
        },
        {
          target: ".dashboard_main_menu_inner",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.mainMenuIntroTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.mainMenuIntro" })),
          placement: "right",          
          onEnteringStepBackwardsClick: "CALCULATIONS",
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // PERIOD ADMIN
        {
          target: ".menu_key_CALCULATIONS",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculations" })),
          placement: "right",
          onEnteringStepForwardsClick: "CALCULATIONS",
        },      
        {
          target: ".menu_key_CALCULATIONS_CLOSED_PERIODS",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.closedPeriodsAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.closedPeriodsAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_CALCULATIONS_ACTUAL_PERIOD",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.periodAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.periodAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_CALCULATIONS_HISTORY",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationsHistoryTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationsHistory" })),
          placement: "right",
        },
        {
          target: ".menu_key_PRE_CALCULATIONS_HISTORY",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.preCalculationsHistoryTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.preCalculationsHistory" })),
          placement: "right",
        },
        {
          target: ".menu_key_ADMIN_SUPERVISORS_REVISIONS_PANEL",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.supervisorsRevisionsPanelTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.supervisorsRevisionsPanel" })),
          placement: "right",
          onEnteringStepBackwardsClick: "CALCULATIONS",
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // METRIC DATA
        {
          target: ".menu_key_ADMIN_CONFIG_METRIC_DATA",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.metricDataTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.metricData" })),
          placement: "right",
          onEnteringStepForwardsClick: "CALCULATIONS",
          onEnteringStepBackwardsClick: "ADMIN_CALCULATION_UNIT_PARENT",
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // CALCULATION UNIT ADMIN
        {
          target: ".menu_key_ADMIN_CALCULATION_UNIT_PARENT",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationUnitTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationUnit" })),
          placement: "right",
          onEnteringStepForwardsClick: "ADMIN_CALCULATION_UNIT_PARENT",
        },
        {
          target: ".menu_key_ADMIN_CALCULATION_UNIT",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationUnitAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationUnitAdmin" })),          
          placement: "right",
        },
        {
          target: ".menu_key_ADMIN_GROUP",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.groupAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.groupAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_ADMIN_CALCULATION_UNIT_PARENT",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.assignCalculationUnitTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.assignCalculationUnit" })),
          placement: "right",
          onEnteringStepBackwardsClick: "ADMIN_CALCULATION_UNIT_PARENT",
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // ENDPOINTS
        {
          target: ".menu_key_ENDPOINT_CONNECTORS",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.endpointsConnectorsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.endpointsConnectors" })),
          placement: "right",
          onEnteringStepForwardsClick: "ENDPOINT_CONNECTORS",
        },
        {
          target: ".menu_key_ENDPOINT_CONNECTORS_PANEL",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.endpointsConnectorsPanelTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.endpointsConnectorsPanel" })),
          placement: "right",
        },
        {
          target: ".menu_key_ENDPOINTS_CONNECTORS_ADMIN",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.endpointsConnectorsAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.endpointsConnectorsAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_ENDPOINTS_CONNECTORS_VARIABLES_ADMIN",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.endpointsConnectorsVariablesAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.endpointsConnectorsVariablesAdmin" })),
          placement: "right",
          onEnteringStepBackwardsClick: "ENDPOINT_CONNECTORS"
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // CONFIG ADMIN
        {
          target: ".menu_key_ADMIN_CONFIG",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.adminConfigTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.adminConfig" })),
          placement: "right",
          onEnteringStepForwardsClick: "ADMIN_CONFIG",
        },
        {
          target: ".menu_key_ADMIN_CONFIG_DIMENSION",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.dimensionAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.dimensionAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_ADMIN_CONFIG_METRIC",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.metricAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.metricAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_ADMIN_CONFIG_VIRTUAL_METRIC",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.virtualMetricAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.virtualMetricAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_ADMIN_CONFIG_METRICS_GROUP",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.metricsGroupAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.metricsGroupAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_ADMIN_CONFIG_POLYNOMIAL",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.polynomialAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.polynomialAdmin" })),
          placement: "right",
          onEnteringStepBackwardsClick: "ADMIN_CONFIG"
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // REPORT TEMPLATES
        {
          target: ".menu_key_REPORT_TEMPLATES",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.reportTemplatesTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.reportTemplates" })),
          placement: "right",
          onEnteringStepForwardsClick: "REPORT_TEMPLATES",
        },
        {
          target: ".menu_key_ADMIN_REPORT_TEMPLATES",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.reportTemplateAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.reportTemplateAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_ADMIN_ASSIGN_REPORT_TEMPLATE_GROUP",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.assignReportTemplateGroupAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.assignReportTemplateGroupAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_ADMIN_ASSIGN_REPORT_TEMPLATE_CALCULATION_UNIT",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.assignReportTemplateCalculationUnitAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.assignReportTemplateCalculationUnitAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_ADMIN_BI_TEMPLATES",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.biTemplateAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.biTemplateAdmin" })),
          placement: "right",
          onEnteringStepBackwardsClick: "REPORT_TEMPLATES"
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // BI REPORTS
        {
          target: ".menu_key_BI_REPORTS",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.biCalculationsSummaryTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.biCalculationsSummary" })),
          placement: "right",
          onEnteringStepForwardsClick: "BI_REPORTS"
        },
        {
          target: ".menu_key_EXPORT_CONFIGURATIONS_ADMIN",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.exportConfigurationsAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.exportConfigurationsAdmin" })),
          placement: "right",          
          onEnteringStepBackwardsClick: "BI_REPORTS"
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // USERS ADMIN
        {
          target: ".menu_key_ADMIN_USERS",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.userAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.userAdmin" })),
          placement: "right",
          onEnteringStepForwardsClick: "BI_REPORTS"
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        {
          target: '.dashboard_content_inner_view',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.tourEndTitle" })),
          content: <div><p>{LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.tourEnd" }))}</p><p style={{textAlign: "center"}}>{LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.tourEndBottomText" }))}</p></div>,
          disableBeacon: true,
          placement: 'center',
        },
      ]
    },
    calculation_unit_admin: {
      requiresPeriod: true,
      steps: [
        {
          target: '.dashboard_content_inner',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.tourIntroTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.tourIntro" })),
          disableBeacon: true,
          placement: 'center',
        },
        {
          target: ".entity_table_component ",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.entityTableTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.entityTable" })),
        },
        {
          target: '[id="periodIdSelected"]',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.periodSelectorTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.periodSelector" })),
          placement: 'bottom',
        },
        {
          target: ".top_controls_show_disabled_entities",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.showDisabledEntitiesTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.showDisabledEntities" })),
        },
        {
          target: ".top_controls_show_audit_info",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.auditInfoButtonTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.auditInfoButton" })),
          placement: "bottom",
        },
        {
          target: ".actions_column ",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.entityTableActionsTitle" })),
          content: <div>
            <p>{LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.entityTableActionsTop" }))}</p>
            <div style={{display: "flex", justifyContent: "center", marginTop: "-15px", marginBottom: "3px"}}><img src={CalculationUnitAdminActionsImg} width="30%"/></div>
            <p>{LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.entityTableActionsMiddle" }))}</p>
            <p>{LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.entityTableActionsBottom" }))}</p>
          </div>,
          placement: "bottom-start"
        },
        {
          target: '[data-field="period_created_at"]',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.periodCreatedAtColumnTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.periodCreatedAtColumn" })),
          placement: "bottom",
        },
        {
          target: "[id=entity_header_form_popup_button] ",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.formPopupButtonTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.formPopupButton" })),
          onEnteringStepBackwardsClick: "glass_popup_close_button",
        },
        {
          target: "body",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.formOpeningButtonTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.formOpeningButton" })),
          onEnteringStepForwardsClick: "entity_header_form_popup_button",
        },
        {
          target: ".glass_popup_content",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.formPopupTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.formPopup" })),
          placement: "left",
        },
        {
          target: "[data-path='calculation_unit.code']",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.formPopupCodeTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.formPopupCode" })),
          placement: "left",
        },
        {
          target: ".entity_metrics_label",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.formPopupMetricsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.formPopupMetrics" })),
          placement: "left",
          onEnteringStepBackwardsClick: "entity_header_form_popup_button",
        },
        {
          target: "[id=entity_header_import_button]",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importButtonTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importButton" })),
          placement: "left-end",
          onEnteringStepForwardsClick: "glass_popup_close_button",
          onEnteringStepBackwardsClick: "glass_popup_close_button",
        },
        {
          target: "[id=entity_header_import_button]",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importPopupOpeningTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importPopupOpening" })),
          placement: "left-end",
          onEnteringStepForwardsClick: "entity_header_import_button",
        },
        {
          target: ".modal-content",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importPopupTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importPopup" })),
          placement: "top",
        },
        {
          target: "[id='import_method']",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importMethodTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importMethod" })),
          placement: "top",
        },
        {
          target: ".form_paragraph",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importTemplateTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importTemplate" })),
          placement: "top",
        },
        {
          target: '[id="import_file"]',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importFileButtonTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importFileButton" })),
          placement: "top",
          onEnteringStepBackwardsClick: "entity_header_import_button",
        },
        {
          target: ".entity_header_import_info_button",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importHistoryButtonTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.importHistoryButton" })),
          onEnteringStepForwardsClick: "glass_popup_close_button",
        },
        {
          target: ".dashboard_content_inner",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.tourEndTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.calculationUnitAdmin.tourEnd" })),          
          placement: "center",
        },
      ],
    },    
    export_configurations_admin: {
      requiresPeriod: true,
      steps: [
        {
          target: '.dashboard_content_inner',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.tourIntroTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.tourIntro" })),
          disableBeacon: true,
          placement: 'center',
        },
        {
          target: '.export_configuration_admin_configuration_filters_and_data_section',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.filtersSectionTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.filtersSection" })),
          placement: "right",
        },
        {
          target: '.export_configuration_admin_table',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportConfigurationsTableTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportConfigurationsTable" })),
        },
        {
          target: '.export_configuration_options_actions_container',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportOptionsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportOptions" })),
        },
        {
          target: '.dashboard_content_inner',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportProcessIntroTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportProcessIntro" })),
          placement: 'center',
        },
        {
          target: '.export_configuration_filters_section',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.calculationUnitsAndGroupsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.calculationUnitsAndGroups" })),
        },
        {
          target: '.metric_groups_and_metrics_data',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.metricsAndMetricGroupsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.metricsAndMetricGroups" })),          
        },
        {
          target: '.reports_filter',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.reportsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.reports" })),
        },
        {
          target: '.models_filter',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.calculationsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.calculations" })),
        },
        {
          target: '.bi_templates_filter',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.BIObjectsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.BIObjects" })),
        },
        {
          target: '.file_structure_options',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.fileStructureOptionsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.fileStructureOptions" })),
        },
        {
          target: '.reprocess_options',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.reprocessOptionsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.reprocessOptions" })),
        },
        {
          target: '.metric_groups_and_metrics_options',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.metricAndMetricGroupsOptionsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.metricAndMetricGroupsOptions" })),
        },
        {
          target: '.save_configuration_button',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.saveConfigurationTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.saveConfiguration" })),
        },
        {
          target: '.export_with_configuration_button',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportConfigurationTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportConfiguration" })),
        },
        {
          target: 'body',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.openExportConfigurationTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.openExportConfiguration" })),
          onEnteringStepForwardsClick: "export_with_configuration_button",
        },
        {
          target: '.export_configuration_period_selector_interface_wrapper',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportConfigurationPopupTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportConfigurationPopup" })),
        },
        {
          target: '.export_configuration_periods_criteria_selector',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.periodFilterTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.periodFilter" })),
          onEnteringStepBackwardsClick: "export_with_configuration_button",
        },
        {
          target: '.dashboard_content_inner',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.tourEndTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.tourEnd" })),
          placement: 'center',
          onEnteringStepForwardsClick: 'glass_popup_close_button',
        }
      ]      
    }
  },  
  period_admin: {
    home: {
      steps: [
        {
          target: '.dashboard_content_inner_view',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.tourIntroTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.tourIntro" })),
          disableBeacon: true,
          placement: 'center',
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // TOP MENU
        {
          target: ".dashboard_top_bar",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuIntroTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuIntro" })),
          placement: "bottom",
        },
        {
          target: ".top_menu_fixed_period",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuFixedPeriodTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuFixedPeriod" })),
          placement: "bottom",
        },
        {
          target: ".fa-tasks",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuNotificationsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuNotifications" })),
          placement: "bottom",
        },
        {
          target: ".fa-user-circle",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuUserProfileTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.topMenuUserProfile" })),
          placement: "bottom",
        },
        {
          target: ".dashboard_main_menu_inner",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.mainMenuIntroTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.mainMenuIntro" })),
          placement: "right",          
          onEnteringStepBackwardsClick: "CALCULATIONS",
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // PERIOD ADMIN
        {
          target: ".menu_key_CALCULATIONS",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculations" })),
          placement: "right",          
          onEnteringStepForwardsClick: "CALCULATIONS",
        },      
        {
          target: ".menu_key_CALCULATIONS_CLOSED_PERIODS",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.closedPeriodsAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.closedPeriodsAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_CALCULATIONS_ACTUAL_PERIOD",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.periodAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.periodAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_CALCULATIONS_HISTORY",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationsHistoryTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationsHistory" })),
          placement: "right",
        },
        {
          target: ".menu_key_PRE_CALCULATIONS_HISTORY",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.preCalculationsHistoryTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.preCalculationsHistory" })),
          placement: "right",
        },
        {
          target: ".menu_key_ADMIN_SUPERVISORS_REVISIONS_PANEL",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.supervisorsRevisionsPanelTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.supervisorsRevisionsPanel" })),
          placement: "right",
          onEnteringStepBackwardsClick: "CALCULATIONS",
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // METRIC DATA
        {
          target: ".menu_key_ADMIN_CONFIG_METRIC_DATA",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.metricDataTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.metricData" })),
          placement: "right",
          onEnteringStepForwardsClick: "CALCULATIONS",
          onEnteringStepBackwardsClick: "ADMIN_CALCULATION_UNIT_PARENT",
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // CALCULATION UNIT ADMIN
        {
          target: ".menu_key_ADMIN_CALCULATION_UNIT_PARENT",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationUnitTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationUnit" })),
          placement: "right",
          onEnteringStepForwardsClick: "ADMIN_CALCULATION_UNIT_PARENT",
        },
        {
          target: ".menu_key_ADMIN_CALCULATION_UNIT",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationUnitAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.calculationUnitAdmin" })),          
          placement: "right",
        },
        {
          target: ".menu_key_ADMIN_GROUP",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.groupAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.groupAdmin" })),
          placement: "right",
        },
        {
          target: ".menu_key_ADMIN_CALCULATION_UNIT_PARENT",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.assignCalculationUnitTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.assignCalculationUnit" })),
          placement: "right",
          onEnteringStepBackwardsClick: "ADMIN_CALCULATION_UNIT_PARENT",
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // ENDPOINTS
        {
          target: ".menu_key_ENDPOINT_CONNECTORS",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.endpointsConnectorsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.endpointsConnectors" })),
          placement: "right",
          onEnteringStepForwardsClick: "ENDPOINT_CONNECTORS",
        },
        {
          target: ".menu_key_ENDPOINT_CONNECTORS_PANEL",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.endpointsConnectorsPanelTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.endpointsConnectorsPanel" })),
          placement: "right",
          onEnteringStepBackwardsClick: "ENDPOINT_CONNECTORS"
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        // BI REPORTS
        {
          target: ".menu_key_BI_REPORTS",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.biCalculationsSummaryTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.biCalculationsSummary" })),
          placement: "right",
          onEnteringStepForwardsClick: "BI_REPORTS"
        },
        {
          target: ".menu_key_EXPORT_CONFIGURATIONS_ADMIN",
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.exportConfigurationsAdminTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.exportConfigurationsAdmin" })),
          placement: "right",          
          onEnteringStepBackwardsClick: "BI_REPORTS"
        },
        // = = = = = = = = = = = = = = = = = = = = = = = = = = 
        {
          target: '.dashboard_content_inner_view',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.tourEndTitle" })),
          content: <div><p>{LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.tourEnd" }))}</p><p style={{textAlign: "center"}}>{LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.home.tourEndBottomText" }))}</p></div>,
          disableBeacon: true,
          placement: 'center',
          onEnteringStepForwardsClick: "BI_REPORTS",
        },
      ]
    },    
    export_configurations_admin: {
      requiresPeriod: true,
      steps: [
        {
          target: '.dashboard_content_inner',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.tourIntroTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.tourIntro" })),
          disableBeacon: true,
          placement: 'center',
        },
        {
          target: '.export_configuration_admin_configuration_filters_and_data_section',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.filtersSectionTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.filtersSection" })),
          placement: "right",
        },
        {
          target: '.export_configuration_admin_table',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportConfigurationsTableTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportConfigurationsTable" })),
        },
        {
          target: '.export_configuration_options_actions_container',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportOptionsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportOptions" })),
        },
        {
          target: '.dashboard_content_inner',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportProcessIntroTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportProcessIntro" })),
          placement: 'center',
        },
        {
          target: '.export_configuration_filters_section',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.calculationUnitsAndGroupsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.calculationUnitsAndGroups" })),
        },
        {
          target: '.metric_groups_and_metrics_data',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.metricsAndMetricGroupsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.metricsAndMetricGroups" })),          
        },
        {
          target: '.reports_filter',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.reportsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.reports" })),
        },
        {
          target: '.models_filter',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.calculationsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.calculations" })),
        },
        {
          target: '.bi_templates_filter',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.BIObjectsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.BIObjects" })),
        },
        {
          target: '.file_structure_options',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.fileStructureOptionsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.fileStructureOptions" })),
        },
        {
          target: '.reprocess_options',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.reprocessOptionsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.reprocessOptions" })),
        },
        {
          target: '.metric_groups_and_metrics_options',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.metricAndMetricGroupsOptionsTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.metricAndMetricGroupsOptions" })),
        },
        {
          target: '.save_configuration_button',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.saveConfigurationTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.saveConfiguration" })),
        },
        {
          target: '.export_with_configuration_button',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportConfigurationTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportConfiguration" })),
        },
        {
          target: 'body',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.openExportConfigurationTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.openExportConfiguration" })),
          onEnteringStepForwardsClick: "export_with_configuration_button",
        },
        {
          target: '.export_configuration_period_selector_interface_wrapper',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportConfigurationPopupTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.exportConfigurationPopup" })),
        },
        {
          target: '.export_configuration_periods_criteria_selector',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.periodFilterTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.periodFilter" })),
          onEnteringStepBackwardsClick: "export_with_configuration_button",
        },
        {
          target: '.dashboard_content_inner',
          title: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.tourEndTitle" })),
          content: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "dashboard.tours.exportConfigurationsAdmin.tourEnd" })),
          placement: 'center',
          onEnteringStepForwardsClick: 'glass_popup_close_button',
        }
      ]      
    },
  }
};

export default onBoardingDefinitions;


// WEBPACK FOOTER //
// ./source/definitions/onBoardingDefinitions.jsx